import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {CatalogEffects} from './catalog.effects';
import {catalogFeatureKey, catalogReducer} from './catalog.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(catalogFeatureKey, catalogReducer),
    EffectsModule.forFeature([CatalogEffects]),
  ],
})
export class CatalogModule {}
